import {
  isCardVisible,
  ROLES,
  useCurrentUserRoles,
  type HudCardVisibility,
} from "@/features/hud/roles";

/**
 * Single source of truth for the finance-surface gate: the same predicate
 * the AR/AP KPI cards declare (owner/admin Relay role AND a Forge role that
 * passes the 1-arg can_access_finance_org() SELECT policy on the
 * public.finance_* tables — see the note in features/hud/roles.ts).
 *
 * Consumed by the /finance route guard (FinanceRoute), the sidebar nav item
 * (AppShell), and the dashboard "Finance" link card, so the three surfaces
 * can never drift apart.
 */
export const FINANCE_DASHBOARD_VISIBILITY: HudCardVisibility = {
  relayRoles: [...ROLES.OWNER_ADMIN],
  requiresAnyForgeRole: [...ROLES.FINANCE_READ],
};

/** Role-gate hook for the finance dashboard surface. */
export function useFinanceAccess(): { allowed: boolean; isLoading: boolean } {
  const roles = useCurrentUserRoles();
  return {
    allowed: isCardVisible(FINANCE_DASHBOARD_VISIBILITY, roles),
    isLoading: roles.isLoading,
  };
}
